/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { get, isEmpty, isNil } from 'lodash';
import { connect, useDispatch } from 'react-redux';
import Keycloak, { KeycloakInstance } from 'keycloak-js';
import { Switch, RouteProps } from 'react-router-dom';
import {
  isManager,
  getRoutesByProfile,
  isTokenNotValid,
  isExpert,
  isUserHasValidRole,
  isOpeningManager,
  isLawyer,
  getInformations,
} from 'containers/AppContainer/utils';
import AppBar from 'containers/AppContainer/AppBar';
import SideBar from 'containers/AppContainer/SideBar';

import {
  makeSelectLawyerNotifications,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectListingsIntervenants,
  makeSelectManagerNotifications,
  makeSelectExpertNotifications,
  makeSelectOpeningManagerNotificationsMixedClaim,
  makeSelectOpenUnlockClaimDialog,
  makeSelectKeycloakToken,
  makeSelectNotificationsInboxes,
  makeSelectCountNotificationManagers,
  makeSelectCountInboxesManagers,
  makeSelectInboxesLawyerNotifications,
  makeSelectCountInboxesLawyerNotifications,
} from 'containers/AppContainer/selectors';
import { resetSagisInfoClaim } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  requestUnlockClaim,
  requestResetHistoryStore,
} from 'containers/CourtManagerLegalProceedings/actions';
import { setLockedClaim } from 'containers/LawyerLegalProceedingsPage/actions';
import { resetStoreClaim } from 'containers/RecapManagerPage/actions';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import userPrivelges from 'containers/services/security/user-privileges';
import { LISTINGS } from 'containers/data-structure';
import { useHealthCheck } from 'hooks/useHealthCheck';
import {
  requestListings,
  setKeycloakToken,
  requestGetLawyerNotifications,
  requestGetManagerNotifications,
  requestGetExpertNotifications,
  requestReadLawyerNotification,
  requestReadManagerNotification,
  requestIntervenants,
  requestLinkToBeneficiaryCodes,
  requestReadExpertNotification,
  requestNotificationOpeningManagerMixedClaim,
  setClaimNumber,
  setNotification,
  requestForceUnlockClaim,
  requestOpenLockClaimDialog,
  setCurrentIndexTabManager,
  setCurrentIndexTabJudiciaryProcessManager,
  setCurrentInstanceTab,
  setCurrentIndexGlobalTabManager,
  setNotificationFeeNote,
  requestReadConvertClaimNotification,
  requestRefreshManager,
  requestGetNotificationsInboxes,
  setCurrentIndexTabExpertise,
  requestGetCountNotificationsInboxes,
  setCurrentIndexTabTransaction,
  setTransactionId,
  setCurrentRegulationPath,
  requestGetInboxesLawyerNotifications,
  requestGetCountInboxesLawyerNotifications,
  setCurrentIndexGlobalTabLawyer,
  setCurrentIndexTabJudiciaryProcessLawyer,
  setCurrentIndexTabLawyer,
} from 'containers/AppContainer/actions';
import * as featureService from 'features/fflip-helpers';
import { requestLogout } from 'containers/LoginPage/actions';
import {
  INotification,
  Listings,
  SagisConfig,
  UserInfo,
} from 'containers/AppContainer/typings';
import useVersionCheck from 'hooks/useCheckVersion';
import currentUserStorage from 'containers/services/security/current-user-storage';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { PropsRoute } from 'containers/services/routes-helper';
import Loader from 'containers/AppContainer/Loader';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import { resetPreopenClaim } from 'containers/PreOpeningPage/actions';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import GATracking from 'components/GATracking/index';
import { TOKEN_LIFE_SPAN_REMAIN_PERIOD } from 'containers/AppContainer/constants';
import { MainContent } from 'containers/AppContainer/style';
import { setSelectedClaim } from 'containers/IdentificationPage/actions';
import UnlockClaimDialog from 'containers/AppContainer/Dialogs/UnlockClaimDialog';
import { getAssignedManagerCode } from 'containers/CourtManagerAssignedClaims/utils';
import {
  userHasPrivilege,
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { FEATURES } from 'features/features';
import RestrictedAccessPage from 'containers/AppContainer/RistrictedAccessPage';
import { isTransactionManager } from 'helpers/utils';
import VersionTag from 'containers/AppContainer/VersionTag';
import ErrorPage from 'containers/ErrorPage';
import { ClaimRecapType } from 'typings/claimTypes';
import OverdueInvoicesCard from 'containers/LawyerFeeNote/OverdueInvoicesCard';
import { requestGetKpiOverdueInvoice } from 'containers/LawyerFeeNote/actions';

export interface AppContainerProps {
  location: { pathname: string };
  intl: IntlShape;
  showStepper?: Boolean;
  children?: React.ReactNode;
  requestListings: Function;
  requestGetLawyerNotifications: Function;
  requestGetManagerNotifications: Function;
  requestReadLawyerNotification: Function;
  requestReadManagerNotification: Function;
  listings: Listings;
  lawyerNotifications: INotification[];
  managerNotifications: INotification[];
  requestLogout: Function;
  setKeycloakToken: Function;
  setLoader: { GLOBAL: boolean };
  resetPreopenClaim: Function;
  requestIntervenants: Function;
  intervenants: SagisConfig[];
  requestLinkToBeneficiaryCodes: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  requestGetExpertNotifications: Function;
  expertNotifications: INotification[];
  requestReadExpertNotification: Function;
  openingManagerNotificationsMixedClaim: INotification[];
  requestNotificationOpeningManagerMixedClaim: Function;
  requestSagisClaimInfo: Function;
  setSelectedClaim: Function;
  setClaimNumber: Function;
  setNotification: Function;
  requestOpenLockClaimDialog: Function;
  requestForceUnlockClaim: Function;
  unlockClaimOpenDialog: boolean;
  setCurrentIndexTabManager: Function;
  setCurrentIndexTabJudiciaryProcessManager: Function;
  setCurrentInstanceTab: Function;
  setCurrentIndexGlobalTabManager: Function;
  setNotificationFeeNote: Function;
  requestReadConvertClaimNotification: Function;
  tokenKeycloak: any;
  requestRefreshManager: Function;
  requestGetNotificationsInboxes: Function;
  notificationsInboxes: any;
  countNotificationManager: any;
  countInboxesNotificationsManager: any;
  setCurrentIndexTabExpertise: Function;
  requestGetCountNotificationsInboxes: Function;
  requestUnlockClaim: Function;
  claimRecap: ClaimRecapType;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  resetSearchClaimsStore: Function;
  requestResetHistoryStore: Function;
  resetSagisInfoClaim: Function;
  setCurrentIndexTabTransaction: Function;
  setTransactionId: Function;
  setCurrentRegulationPath: Function;
  requestGetInboxesLawyerNotifications: Function;
  inboxesLawyerNotifications: any;
  requestGetCountInboxesLawyerNotifications: Function;
  countInboxesLawyerNotifications: any;
  setCurrentIndexGlobalTabLawyer: Function;
  setCurrentIndexTabJudiciaryProcessLawyer: Function;
  setCurrentIndexTabLawyer: Function;
}

export const AppContainer: React.FC<AppContainerProps> = (
  props,
): JSX.Element => {
  const { serverDown } = useHealthCheck(50000);
  const dispatch = useDispatch();

  const [userInfo, setUserInfo] = React.useState<UserInfo | undefined>(
    undefined,
  );
  const [keycloak, setKeycloak] = React.useState<KeycloakInstance | undefined>(
    undefined,
  );
  const [isUserValid, setIsUserValid] = React.useState<boolean>(true);
  const [openInvoiceDialog, setOpenInvoiceDialog] = React.useState<boolean>(
    false,
  );

  const [openSideBar, setOpenSideBar] = useState(true);

  useVersionCheck(props);

  useEffect(() => {
    const keycloakConfig = {
      realm: 'corporeal',
      url: process.env.REACT_APP_KEYCLOAK_URL,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    };

    const keycloak = new Keycloak(keycloakConfig);
    if (!isManager(props)) {
      keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
        if (authenticated) {
          props.setKeycloakToken(keycloak.token);
          keycloak.loadUserInfo().then((userInfo: any) => {
            setUserInfo(userInfo);
            setKeycloak(keycloak);
            GATracking.set(
              'userId',
              isNil(
                get(
                  currentIntervenantStorage?.get(),
                  'preferred_username',
                  null,
                ),
              )
                ? get(currentUserStorage?.get(), 'privileges.sagisName')
                : currentIntervenantStorage?.get()?.preferred_username,
            );
            GATracking.set('dimension1', userInfo.preferred_username);
          });
          // keycloak.logout();
          if (isExpert(props)) {
            props.requestGetExpertNotifications();
          } else {
            props.requestGetLawyerNotifications();
          }
        }
      });

      keycloak.onTokenExpired = () => {
        keycloak.updateToken(TOKEN_LIFE_SPAN_REMAIN_PERIOD).then(refreshed => {
          if (refreshed) {
            props.setKeycloakToken(keycloak.token);
          } else {
            keycloak.logout();
          }
        });
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hasSeenModal = window.localStorage.getItem('showInvoiceKpiModal');
    if (
      userHasPrivilege(PRIVILEGES.ISMANAGER) &&
      !hasSeenModal &&
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
    ) {
      dispatch(requestGetKpiOverdueInvoice());
      window.localStorage.setItem('showInvoiceKpiModal', 'true');
      setOpenInvoiceDialog(true);
    }
  }, []);
  const [page, setPage] = useState(0);

  const assignedManagerCode = getAssignedManagerCode(
    get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
    get(currentUserStorage.get(), 'username', ''),
  );
  const isInboxesActive = featureService.hasFeature(
    FEATURES.ATTRIBUTION_INBOXES_MANAGER,
  );
  const isManagerOpeningManager =
    userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
    userHasPrivilege(PRIVILEGES.ISMANAGER);
  const isPreOpeningManager = userHasPrivilege(PRIVILEGES.ISPREOPENMANAGER);
  const isMonitoringCourtManager =
    userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
    !userHasPrivilege(PRIVILEGES.ISMANAGER);
  const isManagerCourtMonitoringManager =
    userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
    userHasPrivilege(PRIVILEGES.ISMANAGER);
  const istransactionManager = isTransactionManager();
  const isPriorityClaimManager = userHasPrivilege(
    PRIVILEGES.ISPRIORITYCLAIMSMANAGER,
  );
  useEffect(() => {
    if (isManager(props) && !isOpeningManager()) {
      props.requestGetManagerNotifications({
        page: 0,
        assignedManagerCode: assignedManagerCode,
        isManagerOpeningManager,
        isMonitoringCourtManager,
        isManagerCourtMonitoringManager,
        isPreOpeningManager,
        isTransactionManager: istransactionManager,
        userPrivilegesId: get(currentUserStorage.get(), 'privileges.id'),
        isPriorityClaimManager,
      });
    } else if (isOpeningManager()) {
      props.requestNotificationOpeningManagerMixedClaim();
      props.requestGetManagerNotifications({
        page: 0,
        assignedManagerCode: assignedManagerCode,
        isManagerOpeningManager,
        isMonitoringCourtManager,
        isManagerCourtMonitoringManager,
        isPreOpeningManager,
        isTransactionManager: istransactionManager,
        userPrivilegesId: get(currentUserStorage.get(), 'privileges.id'),
        isPriorityClaimManager,
      });
    }
  }, [assignedManagerCode]);

  useEffect(() => {
    const inboxes = userPrivelges
      .getUserInboxes()
      .map((el: any) => el.managerInboxesId);
    const transactionAreaInboxes = userPrivelges
      .getUserInboxes()
      .map((el: any) =>
        !isNil(el.transactionInboxeAreaId)
          ? el.transactionInboxeAreaId
          : undefined,
      )
      .filter((element: any) => element);
    if (isInboxesActive && isManager(props)) {
      props.requestGetCountNotificationsInboxes({
        inboxes,
        transactionAreaInboxes,
        isPriorityClaimsManager: isPriorityClaimManager,
      });
    }
  }, [isInboxesActive]);
  useEffect(() => {
    if (
      !isUserHasValidRole(
        get(userInfo, 'roles', []),
        props.intervenants,
        get(userInfo, 'sagis_code', ''),
      ) &&
      !isManager(props)
    ) {
      /* TO DO
      keycloak?.logout();
      */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.intervenants, keycloak, userInfo]);
  useEffect(() => {
    props.requestIntervenants();
    props.requestLinkToBeneficiaryCodes();
    props.requestListings();
  }, [props.tokenKeycloak]);
  const routes = getRoutesByProfile(props) as [];

  if (isTokenNotValid(props)) {
    pushTo(PAGES.LOGIN_MANAGER)();
  }
  const handleClose = () => props.requestOpenLockClaimDialog(false);

  useEffect(() => {
    if (
      !get(props.listings, LISTINGS.INTERVENANT_NAME, []).find(
        (el: any) => el.ItemKey === get(userInfo, 'sagis_code'),
      ) &&
      !isEmpty(props.listings) &&
      userInfo
    )
      setIsUserValid(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings, userInfo]);

  const successCallBackRefresh = () => {
    if (isManager(props) && !isOpeningManager()) {
      props.requestGetManagerNotifications({
        page: 0,
        assignedManagerCode: assignedManagerCode,
        isManagerOpeningManager,
        isMonitoringCourtManager,
        isManagerCourtMonitoringManager,
        isPreOpeningManager,
        isTransactionManager: istransactionManager,
        userPrivilegesId: get(currentUserStorage.get(), 'privileges.id'),
        isPriorityClaimManager,
      });
    } else if (isOpeningManager()) {
      props.requestNotificationOpeningManagerMixedClaim();
      props.requestGetManagerNotifications({
        page: 0,
        assignedManagerCode: assignedManagerCode,
        isManagerOpeningManager,
        isMonitoringCourtManager,
        isManagerCourtMonitoringManager,
        isPreOpeningManager,
        isTransactionManager: istransactionManager,
        userPrivilegesId: get(currentUserStorage.get(), 'privileges.id'),
        isPriorityClaimManager,
      });
    }
  };

  const isLawyerInboxesActive = featureService.hasFeature(
    FEATURES.LAWYER_INBOXES,
  );
  useEffect(() => {
    if (isLawyerInboxesActive && isLawyer()) {
      props.requestGetCountInboxesLawyerNotifications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLawyerInboxesActive]);

  return (
    <>
      <div>
        {serverDown &&
        featureService.hasFeature(FEATURES.HEALTH_CHECK_POLLING) ? (
          <ErrorPage />
        ) : !isUserValid ? (
          <RestrictedAccessPage />
        ) : (
          <div>
            {props.setLoader && props.setLoader.GLOBAL && (
              <Loader withOpacity={false} />
            )}
            <AppBar
              userInfo={getInformations(props, keycloak, userInfo).userInfo}
              logout={getInformations(props, keycloak, userInfo).logout}
              location={props.location}
              listings={props.listings}
              lawyerNotifications={props.lawyerNotifications}
              managerNotifications={props.managerNotifications}
              requestReadLawyerNotification={
                props.requestReadLawyerNotification
              }
              requestReadManagerNotification={
                props.requestReadManagerNotification
              }
              expertNotifications={props.expertNotifications}
              requestReadExpertNotification={
                props.requestReadExpertNotification
              }
              openingManagerNotificationsMixedClaim={
                props.openingManagerNotificationsMixedClaim
              }
              setClaimNumber={props.setClaimNumber}
              setSelectedClaim={props.setSelectedClaim}
              setNotification={props.setNotification}
              setCurrentIndexTabManager={props.setCurrentIndexTabManager}
              setCurrentIndexTabJudiciaryProcessManager={
                props.setCurrentIndexTabJudiciaryProcessManager
              }
              setCurrentInstanceTab={props.setCurrentInstanceTab}
              setCurrentIndexGlobalTabManager={
                props.setCurrentIndexGlobalTabManager
              }
              setNotificationFeeNote={props.setNotificationFeeNote}
              loaders={props.setLoader}
              requestReadConvertClaimNotification={
                props.requestReadConvertClaimNotification
              }
              requestRefreshManager={props.requestRefreshManager}
              requestGetManagerNotifications={
                props.requestGetManagerNotifications
              }
              setPage={setPage}
              page={page}
              notificationsInboxes={props.notificationsInboxes}
              countNotificationsManager={props.countNotificationManager}
              countInboxesNotificationsManager={
                props.countInboxesNotificationsManager
              }
              setCurrentIndexTabExpertise={props.setCurrentIndexTabExpertise}
              requestGetNotificationsInboxes={
                props.requestGetNotificationsInboxes
              }
              successCallBackRefresh={successCallBackRefresh}
              requestUnlockClaim={props.requestUnlockClaim}
              claimRecap={props.claimRecap}
              setLockedClaim={props.setLockedClaim}
              resetStoreClaim={props.resetStoreClaim}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              requestResetHistoryStore={props.requestResetHistoryStore}
              resetSagisInfoClaim={props.resetSagisInfoClaim}
              setCurrentIndexTabTransaction={
                props.setCurrentIndexTabTransaction
              }
              setTransactionId={props.setTransactionId}
              setCurrentRegulationPath={props.setCurrentRegulationPath}
              requestGetInboxesLawyerNotifications={
                props.requestGetInboxesLawyerNotifications
              }
              inboxesLawyerNotifications={props.inboxesLawyerNotifications}
              countInboxesLawyerNotifications={
                props.countInboxesLawyerNotifications
              }
              setCurrentIndexGlobalTabLawyer={
                props.setCurrentIndexGlobalTabLawyer
              }
              setCurrentIndexTabJudiciaryProcessLawyer={
                props.setCurrentIndexTabJudiciaryProcessLawyer
              }
              setCurrentIndexTabLawyer={props.setCurrentIndexTabLawyer}
            />
            <div style={{ display: 'flex' }}>
              <SideBar
                isManager={isManager(props)}
                isExpert={isExpert(props)}
                resetClaim={props.resetPreopenClaim}
                open={openSideBar}
                setOpen={setOpenSideBar}
              />
              <MainContent className="content" openSideBar={openSideBar}>
                <Switch>
                  {routes.map((props: RouteProps, idx: number) => (
                    <PropsRoute key={idx} {...props} {...userInfo} />
                  ))}
                </Switch>
              </MainContent>
            </div>
          </div>
        )}
        <UnlockClaimDialog
          open={props.unlockClaimOpenDialog}
          onClose={handleClose}
          validateDialog={props.requestForceUnlockClaim}
        />
        {isManager(props) && <VersionTag />}
        {userHasPrivilege(PRIVILEGES.ISMANAGER) &&
          featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) && (
            <OverdueInvoicesCard
              open={openInvoiceDialog}
              onClose={() => setOpenInvoiceDialog(false)}
              listings={props.listings}
            />
          )}
      </div>
    </>
  );
};

AppContainer.defaultProps = {
  showStepper: false,
};

const mapDispatchToProps = {
  requestListings,
  requestIntervenants,
  requestGetLawyerNotifications,
  requestGetManagerNotifications,
  requestReadLawyerNotification,
  requestReadManagerNotification,
  requestLogout,
  setKeycloakToken,
  resetPreopenClaim,
  requestLinkToBeneficiaryCodes,
  requestGetExpertNotifications,
  requestReadExpertNotification,
  requestNotificationOpeningManagerMixedClaim,
  setSelectedClaim,
  setClaimNumber,
  setNotification,
  requestForceUnlockClaim,
  requestOpenLockClaimDialog,
  setCurrentIndexTabManager,
  setCurrentIndexTabJudiciaryProcessManager,
  setCurrentInstanceTab,
  setCurrentIndexGlobalTabManager,
  setNotificationFeeNote,
  requestReadConvertClaimNotification,
  requestRefreshManager,
  requestGetNotificationsInboxes,
  setCurrentIndexTabExpertise,
  requestGetCountNotificationsInboxes,
  setLockedClaim,
  resetStoreClaim,
  resetSearchClaimsStore,
  requestResetHistoryStore,
  requestUnlockClaim,
  resetSagisInfoClaim,
  setCurrentIndexTabTransaction,
  setTransactionId,
  setCurrentRegulationPath,
  requestGetInboxesLawyerNotifications,
  requestGetCountInboxesLawyerNotifications,
  setCurrentIndexGlobalTabLawyer,
  setCurrentIndexTabJudiciaryProcessLawyer,
  setCurrentIndexTabLawyer,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  intervenants: makeSelectListingsIntervenants(),
  lawyerNotifications: makeSelectLawyerNotifications(),
  managerNotifications: makeSelectManagerNotifications(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  expertNotifications: makeSelectExpertNotifications(),
  openingManagerNotificationsMixedClaim: makeSelectOpeningManagerNotificationsMixedClaim(),
  setLoader: selectedLoader,
  unlockClaimOpenDialog: makeSelectOpenUnlockClaimDialog(),
  tokenKeycloak: makeSelectKeycloakToken(),
  notificationsInboxes: makeSelectNotificationsInboxes(),
  countNotificationManager: makeSelectCountNotificationManagers(),
  countInboxesNotificationsManager: makeSelectCountInboxesManagers(),
  inboxesLawyerNotifications: makeSelectInboxesLawyerNotifications(),
  countInboxesLawyerNotifications: makeSelectCountInboxesLawyerNotifications(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AppContainer));
